import { useEffect, useState } from "react";
import { Label } from "@radix-ui/react-label";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "./ui/card";
import { Input } from "./ui/input";
import './LoginForm.css';
import { NavLink, useNavigate } from "react-router-dom";
import { AuthService } from "../services/auth.service";
import { customSwalStyling, DataService } from "../services/data.service";
import { debugModeActive } from "../lib/utils";
import { AuthModel } from "../models/auth.model";
import Swal from "sweetalert2";

export function LoginForm() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  //@ts-ignore
  window.DoLogin = async (username, password) => {
    if (await DataService.login(username, password)) {
      navigate("/dashboard", { replace: true })
    }
  }

  //@ts-ignore
  window.MobileAppLogin = async (auth: AuthModel) => {
    localStorage.setItem('is_mobile', '1')
    Swal.fire({
      title: "Please wait",
      text: "We are processing your request!",
      customClass: customSwalStyling,
      didOpen: () => {
        Swal.showLoading()
      }
    })

    setTimeout(() => {
      AuthService.saveAuth(auth)
      Swal.close()
      navigate('/dashboard', { replace: true })
    }, 2000)
  }

  useEffect(() => {
    document.body.style.background = "white";
    if (AuthService.hasAuth()) {
      navigate('/dashboard', { replace: true })
      return
    }
  }, [])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (await DataService.login(username, password)) {
      navigate("/dashboard", { replace: true })
    }
  }

  return (
    <div className="login-container">
      <Card className="login-card">
        <div className="login-image">
          <img src="/assets/login-backgroud.png" alt="Login Background" />
        </div>
        <div className="card-white">
          <CardHeader>
            <CardTitle className="card-title">WellNuo</CardTitle>
            <CardDescription className="card-desc">So you know they are well</CardDescription>
          </CardHeader>
          <CardContent>
            <form className="login-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <Label htmlFor="email">Username</Label>
                <Input
                  id="username"
                  type="text"
                  placeholder="Enter your username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              <div className="form-group">
                <Label htmlFor="password">Password</Label>
                <Input
                  id="password"
                  type="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <Button type="submit" className="login-button bg-blue-500 hover:bg-blue-600">
                Log In
              </Button>
              <NavLink to="/signup"
                className="text-blue-500 underline text-center hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500">
                I don't have an account, signup now!
              </NavLink>
            </form>
          </CardContent>
        </div>
        {debugModeActive() && <p className="text-center text-gray-400 mt-1">Build Version: {process.env.REACT_APP_VERSION}</p>}
      </Card>
    </div>
  );
}
